// extracted by mini-css-extract-plugin
module.exports = {"colorText":"#424242","colorPrimary":"#1688fe","colorIcon":"#777777","spaceXXS":"calc(0.25 * 1rem)","spaceXS":"calc(0.5 * 1rem)","borderRadiusControls":"8px"};